<template>
    <copy-text-value
        :text="text"
        :copy-value="copyValue"
        :empty-text="emptyText"
        :title="title"
        :show-copy="showCopy"
    />
</template>

<script>
import CopyTextValue from "./copy-text.vue";

export default {
    name: "CopyableContact",
    components: {
        CopyTextValue,
    },
    props: {
        text: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "复制联系方式",
        },
        emptyText: {
            type: String,
            default: "-",
        },
        copyValue: {
            type: String,
            default: "",
        },
        showCopy: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
